module.exports = __webpack_public_path__ + "media/images/emblems/Flims_wappen-f3bd29e02037757014fe31a343672dd9.svg";